import { render, staticRenderFns } from "./textInput.vue?vue&type=template&id=5c30fab8"
import script from "./textInput.vue?vue&type=script&lang=js"
export * from "./textInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports